<!--<ul>
    <li [ngClass]="{'error': (changePassword ? (!validateIdenticalFields()  || !validateRequired()) : false)}">-->
<div [hidden]="!includeLabel">
    <label for="{{name}}">{{getLabelName()}}</label>
</div>
<input type="password" #field class="form-control" [id]="(id === null ? name : id)" [name]="name" [value]="value"
    [disabled]="disableFields()" (input)="changeValue($event)" />
<!--</li>
    <li *ngIf="inputMode != inputModeEnum.iprmEnterPassword" [ngClass]="{'error': (changePassword ? (!validateIdenticalFields()  || !validateRequired()) : false)}">-->
<div [hidden]="!includeLabel" *ngIf="inputMode !== 3">
    <label for="confirmPasswordFieldName">{{confirmPasswordLabelName()}}</label>
</div>
<input type="password" #confirmField class="form-control" [id]="confirmPasswordFieldName" *ngIf="inputMode !== 3"
    [name]="confirmPasswordFieldName" [value]="confirmValue" [disabled]="disableFields()"
    (input)="changeValueConfirmField($event)" />
<!--</li> -->


<div [ngClass]="{'help-block mt-1 text-danger error': !validateIdenticalFields()}">
    <app-input-feedback [hidden]="validateIdenticalFields()" [feedbackMessage]="spanIdenticalFields">
    </app-input-feedback>
</div>
<div
    [ngClass]="{'help-block mt-1 text-danger error': (changePassword ? (!validateIdenticalFields()  || !validateRequired()) : false)}">
    <app-input-feedback [hidden]="validateRequired()" [feedbackMessage]="spanRequired"></app-input-feedback>
</div>
<div [hidden]="inputMode != inputModeEnum.iprmEdit">
    <a #changePasswordField name="changePassword" id="changePassword" href="javascript:void(0)"
        (click)="setChangePassword($event)" value="changePassword"><i class="ft-alert-circle align-middle me-2"></i>{{
        spanChangePassword }}</a>
</div>
<!--</ul>-->